import { render, staticRenderFns } from "./ClvrScreenControlMaterialAndRemarkNoteCell.vue?vue&type=template&id=044b805e"
import script from "./ClvrScreenControlMaterialAndRemarkNoteCell.ts?vue&type=script&lang=ts&external"
export * from "./ClvrScreenControlMaterialAndRemarkNoteCell.ts?vue&type=script&lang=ts&external"
import style0 from "./ClvrScreenControlMaterialAndRemarkNoteCell.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports